import classnames from "classnames";
import { string } from "prop-types";

const Skeleton = ({ className, variant = "rectangular" }) => {
  const variantClasses = {
    rectangular: "rounded",
    circular: "rounded-full",
    text: "rounded h-4",
  };

  return (
    <div
      className={classnames(
        "animate-pulse bg-muted-foreground/10",
        variantClasses[variant],
        className
      )}
    />
  );
};

Skeleton.propTypes = {
  className: string,
  variant: string,
};

export default Skeleton;
